// src/components/BoardPack/pages/donut_chart_18.jsx
import React, { useState, useEffect, useRef } from "react";
import ErrorState from "@/components/common/ErrorStateComponent";
import LoadingComponent from "@/components/common/LoadingComponent";
import HeadingComponent from "@/components/BoardPack/components/shared/heading";
import DonutChart3 from "@/components/BoardPack/components/charts/DonutChart3";

const COLORS = {
  CASH: "#FF8A3C",
  CARD: "#48A5F6",
  POS: "#48A5F6",
  APM: "#2E7ABF",
  APP_WEB: "#c9611a",
  VERIFIER: "#FF9044",
  PND: "#FF8A3C",
  COINS: "#48A5F6",
  EWALLET: "#2E7ABF",
  NOTES: "#FF9044",
  VERIFIER_SALIK: "#FF8A3C",
  VALET: "#FF8A3C",
};

const DonutChart18 = ({ year = "", month = "", monthNumber = "", contract = "", page = null }) => {
  const showSalik = page?.showSalik === "true" || page?.showSalik === true ? true : false;
  const showValet = page?.showValet === "true" || page?.showValet === true ? true : false;

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cashCardData, setCashCardData] = useState([]);
  const [paymentTypeData, setPaymentTypeData] = useState([]);

  const paramsValueType = page.params.value_type;
  useEffect(() => {
    fetchParkingKPI();
  }, [year, month, contract,paramsValueType]);

 const fetchParkingKPI = async () => {
  try {
    setLoading(true);
    setError(null);

    const apiParams = {};
    if (page?.params) {
      Object.keys(page.params).forEach((key) => {
        let value = page.params[key];
        if (typeof value === "string") {
          value = value.replace("{{year}}", year);
          value = value.replace("{{month}}", month);
        }
        apiParams[key] = value;
      });
    }

    const response = await mockApiCall(apiParams);    
    // Use the contract from the response meta instead of apiParams
    const contractId = response.meta?.contract;
    const contractData = response.data?.[contractId] || {};
    
    const years = Object.keys(contractData).sort();
    const valueType = Number(apiParams.value_type || page?.params?.value_type || 1);

    let newCashCard = [];
    let newPaymentTypes = [];

    if (valueType === 1) {
      newCashCard = years.map((yr) => {
        const yData = contractData[yr];
        return {
          year: yr,
          cash: Number(yData?.cashCard?.cash?.percent_value?.toFixed(2) || 0),
          card: Number(yData?.cashCard?.card?.percent_value?.toFixed(2) || 0),
        };
      });

      newPaymentTypes = years.map((yr) => {
        const yData = contractData[yr];
        return {
          year: yr,
          pos: Number(yData?.payLocation?.POS?.percent_value?.toFixed(2) || 0),
          apm: Number(yData?.payLocation?.APM?.percent_value?.toFixed(2) || 0),
          appWeb: Number(yData?.payLocation?.["APP/WEB"]?.percent_value?.toFixed(2) || 0),
          verifier: Number(yData?.payLocation?.VERIFIER?.percent_value?.toFixed(2) || 0),
          verifierSalik: Number(
            yData?.payLocation?.VERIFIER_SALIK?.percent_value?.toFixed(2) || 0
          ),
          VALET: Number(yData?.payLocation?.VALET?.percent_value?.toFixed(2) || 0),
        };
      });
    } else if (valueType === 2) {
      newCashCard = years.map((yr) => {
        const yData = contractData[yr];
        return {
          year: yr,
          cash: Number(yData?.cashSourceSplit?.POS?.percent_value?.toFixed(2) || 0),
          card: Number(yData?.cashSourceSplit?.APM?.percent_value?.toFixed(2) || 0),
        };
      });

      newPaymentTypes = years.map((yr) => {
        const yData = contractData[yr];
        return {
          year: yr,
          pos: Number(yData?.cardSourceSplit?.POS?.percent_value?.toFixed(2) || 0),
          apm: Number(yData?.cardSourceSplit?.APM?.percent_value?.toFixed(2) || 0),
          appWeb: Number(yData?.cardSourceSplit?.["APP/WEB"]?.percent_value?.toFixed(2) || 0),
          verifier: Number(yData?.cardSourceSplit?.VERIFIER?.percent_value?.toFixed(2) || 0),
          verifierSalik: Number(
            yData?.cardSourceSplit?.VERIFIER_SALIK?.percent_value?.toFixed(2) || 0
          ),
          VALET: Number(yData?.cardSourceSplit?.VALET?.percent_value?.toFixed(2) || 0),
        };
      });
    } else if (valueType === 3) {
      newCashCard = years.map((yr) => {
        const yData = contractData[yr]?.sourceCashCardSplit || {};
        const apm = yData.APM || {};
        return {
          year: yr,
          cash: Number(apm.cash?.percent_value?.toFixed(2) || 0),
          card: Number(apm.card?.percent_value?.toFixed(2) || 0),
        };
      });

      newPaymentTypes = years.map((yr) => {
        const yData = contractData[yr]?.sourceCashCardSplit || {};
        const pos = yData.POS || {};
        return {
          year: yr,
          pos: Number(pos.cash?.percent_value?.toFixed(2) || 0),
          apm: Number(pos.card?.percent_value?.toFixed(2) || 0),
          appWeb: 0,
          verifier: 0,
          verifierSalik: Number(yData?.VERIFIER_SALIK?.percent_value?.toFixed(2) || 0),
          VALET: Number(yData?.VALET?.percent_value?.toFixed(2) || 0),
        };
      });
    } else if (valueType === 4) {
      newCashCard = years.map((yr) => {
        const yData = contractData[yr];
        return {
          year: yr,
          pnd: Number(yData?.pndAppWeb?.PND?.percent_value?.toFixed(2) || 0),
          appWeb: Number(yData?.pndAppWeb?.["APP/WEB"]?.percent_value?.toFixed(2) || 0),
        };
      });

      newPaymentTypes = years.map((yr) => {
        const yData = contractData[yr];
        return {
          year: yr,
          coins: Number(yData?.pndSplit?.["PND :: COINS"]?.percent_value?.toFixed(2) || 0),
          ewallet: Number(yData?.pndSplit?.["PND :: EWALLET"]?.percent_value?.toFixed(2) || 0),
          notes: Number(yData?.pndSplit?.["PND :: NOTES"]?.percent_value?.toFixed(2) || 0),
          verifierSalik: Number(
            yData?.payLocation?.VERIFIER_SALIK?.percent_value?.toFixed(2) || 0
          ),
          VALET: Number(yData?.payLocation?.VALET?.percent_value?.toFixed(2) || 0),
        };
      });
    }

    setCashCardData(newCashCard);
    setPaymentTypeData(newPaymentTypes);
  } catch (err) {
    console.error("Failed to load KPI data:", err);
    setError(err.message || "Failed to load parking data");
  } finally {
    setLoading(false);
  }
};

  if (loading) return <LoadingComponent />;
  if (error) return <ErrorState error={error} onRetry={fetchParkingKPI} />;

  const title = page?.title;
  const subtitle = page?.subtitle;
  const in_chart_content_line_1 = page?.in_chart_content_line_1;
  const in_chart_content_line_2 = page?.in_chart_content_line_2;

  const valueType = Number(page?.params?.value_type || 1);

  // ── First Chart Config ───────────────────────────────────────────────────
  let firstChartLabels = ["Cash", "Card"];
  let firstChartColors = [COLORS.CASH, COLORS.CARD];
  let firstChartLegend = [
    { label: "CASH", color: COLORS.CASH },
    { label: "CARD", color: COLORS.CARD },
  ];

  if (valueType === 2) {
    firstChartLabels = ["POS", "APM"];
    firstChartColors = [COLORS.CASH, COLORS.CARD];
    firstChartLegend = [
      { label: "POS", color: COLORS.CASH },
      { label: "APM", color: COLORS.CARD },
    ];
  } else if (valueType === 4) {
    firstChartLabels = ["PND", "APP/WEB"];
    firstChartColors = [COLORS.PND, COLORS.APP_WEB];
    firstChartLegend = [
      { label: "PND", color: COLORS.PND },
      { label: "APP/WEB", color: COLORS.APP_WEB },
    ];
  }

  // ── Second Chart Config ──────────────────────────────────────────────────
  let secondChartLabels = ["POS", "APM", "APP/WEB", "VERIFIER"];
  let secondChartColors = [COLORS.POS, COLORS.APM, COLORS.APP_WEB, COLORS.VERIFIER];
  let secondChartLegend = [
    { label: "POS", color: COLORS.POS },
    { label: "APM", color: COLORS.APM },
    { label: "APP/WEB", color: COLORS.APP_WEB },
    { label: "VERIFIER", color: COLORS.VERIFIER },
  ];

  if (valueType === 3) {
    secondChartLabels = ["Cash", "Card"];
    secondChartColors = [COLORS.POS, COLORS.APM];
    secondChartLegend = [
      { label: "CASH", color: COLORS.POS },
      { label: "CARD", color: COLORS.APM },
    ];
  } else if (valueType === 4) {
    secondChartLabels = ["COINS", "EWALLET", "NOTES"];
    secondChartColors = [COLORS.COINS, COLORS.EWALLET, COLORS.NOTES];
    secondChartLegend = [
      { label: "COINS", color: COLORS.COINS },
      { label: "EWALLET", color: COLORS.EWALLET },
      { label: "NOTES", color: COLORS.NOTES },
    ];
  }
  if (showSalik) {
    secondChartLabels.push("VERIFIER SALIK");
    secondChartColors.push(COLORS.VERIFIER_SALIK);
    secondChartLegend.push({ label: "VERIFIER SALIK", color: COLORS.VERIFIER_SALIK });
  }
  if (showValet) {
    secondChartLabels.push("VALET");
    secondChartColors.push(COLORS.VALET);
    secondChartLegend.push({ label: "VALET", color: COLORS.VALET });
  }

  // ── Helper: get chart data array per value_type ──────────────────────────
  const getFirstChartData = (d) => {
    if (valueType === 4) return [d.pnd, d.appWeb];
    return [d.cash, d.card]; // type 1, 2, 3
  };

  // const getSecondChartData = (d) => {
  //     if (valueType === 3) return [d.pos, d.apm];
  //     if (valueType === 4) return [d.coins, d.ewallet, d.notes];
  //     return [d.pos, d.apm, d.appWeb, d.verifier]; // type 1 & 2
  // };

  const getSecondChartData = (d) => {
    let data = [];

    if (valueType === 3) {
      data = [d.pos, d.apm];
    } else if (valueType === 4) {
      data = [d.coins, d.ewallet, d.notes];
    } else {
      data = [d.pos, d.apm, d.appWeb, d.verifier];
    }

    if (showSalik) {
      data.push(d.verifierSalik);
    }
    if (showValet) {
      data.push(d.VALET);
    }

    return data;
  };
  return (
    <div className="w-full p-5 bg-background">
      <div className="w-full mx-auto">
        <div className="flex flex-col gap-1 mb-1">
          {title && <HeadingComponent variant={"main"}>{title}</HeadingComponent>}
          {subtitle && <HeadingComponent variant={"sub"}>{subtitle}</HeadingComponent>}
        </div>

        <div className="bg-red-700 dark:bg-red-600 h-6 w-full" />
        <div className="bg-gray-900 dark:bg-gray-950 py-4">
          {/* First Chart Section */}
          <div className="overflow-hidden shadow-lg">
           
            {in_chart_content_line_1 && (
              <h3 className="text-center font-bold text-xs mb-2 text-white">
                {in_chart_content_line_1.split(/(\([^)]+\))/g).map((part, index) => {
                  if (part.startsWith("(") && part.endsWith(")")) {
                    return (
                      <span key={index} className="text-yellow-400">
                        {part}
                      </span>
                    );
                  }
                  return part;
                })}
              </h3>
            )}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 place-items-center mx-4 py-12 bg-white dark:bg-gray-800">
              {cashCardData.map((data) => (
                <div key={data.year} className="flex justify-center items-center">
                  <DonutChart3
                    data={getFirstChartData(data)}
                    labels={firstChartLabels}
                    colors={firstChartColors}
                    year={data.year}
                    legendItems={firstChartLegend}
                    size={280}
                    cutoutPercentage={65}
                    labelPosition="outside"
                    labelStyle="simple"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Second Chart Section */}
          <div className="overflow-hidden shadow-lg">
            {/* {in_chart_content_line_2 && (
                            <h3 className="text-center font-bold my-2 text-xs text-white">
                                {in_chart_content_line_2}
                            </h3>
                        )} */}

            {in_chart_content_line_2 && (
              <h3 className="text-center font-bold my-2 text-xs text-white">
                {in_chart_content_line_2.split(/(\([^)]+\))/g).map((part, index) => {
                  if (part.startsWith("(") && part.endsWith(")")) {
                    return (
                      <span key={index} className="text-yellow-400">
                        {part}
                      </span>
                    );
                  }
                  return part;
                })}
              </h3>
            )}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 place-items-center mx-4 py-12 bg-white dark:bg-gray-800">
              {paymentTypeData.map((data) => (
                <div key={data.year} className="flex justify-center items-center">
                  <DonutChart3
                    data={getSecondChartData(data)}
                    labels={secondChartLabels}
                    colors={secondChartColors}
                    year={data.year}
                    legendItems={secondChartLegend}
                    size={280}
                    cutoutPercentage={65}
                    labelPosition="outside"
                    labelStyle="detailed"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DonutChart18;
const mockApiCall = (params) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const valueType = Number(params.value_type || 1);

      // Mock data structure based on your provided examples
      const mockDataMap = {
        // Contract 0030010 for value types 1, 2, 3
        "0030010": {
          1: {
            "2024": {
              cashCard: {
                cash: { value: 272341.95, percent_value: 29.56, percent: "29.56%" },
                card: { value: 649030, percent_value: 70.44, percent: "70.44%" }
              },
              payLocation: {
                POS: { value: 0, percent_value: 0, percent: "0%" },
                APM: { value: 889961.95, percent_value: 96.59, percent: "96.59%" },
                "APP/WEB": { value: 31410, percent_value: 3.41, percent: "3.41%" },
                VERIFIER: { value: 0, percent_value: 0, percent: "0%" },
                VERIFIER_SALIK: { value: 0, percent_value: 0, percent: "0%" },
                VALET: { value: 0, percent_value: 0, percent: "0%" }
              },
              totals: { grand_total: 921371.95 }
            },
            "2025": {
              cashCard: {
                cash: { value: 568852.75, percent_value: 70.14, percent: "70.14%" },
                card: { value: 242175, percent_value: 29.86, percent: "29.86%" }
              },
              payLocation: {
                POS: { value: 444135, percent_value: 54.76, percent: "54.76%" },
                APM: { value: 354272.75, percent_value: 43.68, percent: "43.68%" },
                "APP/WEB": { value: 12620, percent_value: 1.56, percent: "1.56%" },
                VERIFIER: { value: 0, percent_value: 0, percent: "0%" },
                VERIFIER_SALIK: { value: 0, percent_value: 0, percent: "0%" },
                VALET: { value: 0, percent_value: 0, percent: "0%" }
              },
              totals: { grand_total: 811027.75 }
            },
            "2026": {
              cashCard: {
                cash: { value: 243042.40, percent_value: 68.90, percent: "68.90%" },
                card: { value: 109690, percent_value: 31.10, percent: "31.10%" }
              },
              payLocation: {
                POS: { value: 197925, percent_value: 56.11, percent: "56.11%" },
                APM: { value: 150397.40, percent_value: 42.64, percent: "42.64%" },
                "APP/WEB": { value: 4410, percent_value: 1.25, percent: "1.25%" },
                VERIFIER: { value: 0, percent_value: 0, percent: "0%" },
                VERIFIER_SALIK: { value: 0, percent_value: 0, percent: "0%" },
                VALET: { value: 0, percent_value: 0, percent: "0%" }
              },
              totals: { grand_total: 352732.40 }
            }
          },
          2: {
            "2024": {
              cashSourceSplit: {
                POS: { value: 0, percent_value: 0, percent: "0%" },
                APM: { value: 272341.95, percent_value: 100, percent: "100%" },
                total: 272341.95
              },
              cardSourceSplit: {
                POS: { value: 0, percent_value: 0, percent: "0%" },
                APM: { value: 617620, percent_value: 95.16, percent: "95.16%" },
                "APP/WEB": { value: 31410, percent_value: 4.84, percent: "4.84%" },
                VERIFIER: { value: 0, percent_value: 0, percent: "0%" },
                VERIFIER_SALIK: { value: 0, percent_value: 0, percent: "0%" },
                total: 649030
              }
            },
            "2025": {
              cashSourceSplit: {
                POS: { value: 444135, percent_value: 78.08, percent: "78.08%" },
                APM: { value: 124717.75, percent_value: 21.92, percent: "21.92%" },
                total: 568852.75
              },
              cardSourceSplit: {
                POS: { value: 0, percent_value: 0, percent: "0%" },
                APM: { value: 229555, percent_value: 94.79, percent: "94.79%" },
                "APP/WEB": { value: 12620, percent_value: 5.21, percent: "5.21%" },
                VERIFIER: { value: 0, percent_value: 0, percent: "0%" },
                VERIFIER_SALIK: { value: 0, percent_value: 0, percent: "0%" },
                total: 242175
              }
            },
            "2026": {
              cashSourceSplit: {
                POS: { value: 197925, percent_value: 81.44, percent: "81.44%" },
                APM: { value: 45117.40, percent_value: 18.56, percent: "18.56%" },
                total: 243042.40
              },
              cardSourceSplit: {
                POS: { value: 0, percent_value: 0, percent: "0%" },
                APM: { value: 105280, percent_value: 95.98, percent: "95.98%" },
                "APP/WEB": { value: 4410, percent_value: 4.02, percent: "4.02%" },
                VERIFIER: { value: 0, percent_value: 0, percent: "0%" },
                VERIFIER_SALIK: { value: 0, percent_value: 0, percent: "0%" },
                total: 109690
              }
            }
          },
          3: {
            "2024": {
              sourceCashCardSplit: {
                APM: {
                  cash: { value: 272341.95, percent_value: 30.60, percent: "30.60%" },
                  card: { value: 617620, percent_value: 69.40, percent: "69.40%" },
                  total: 889961.95
                },
                POS: {
                  cash: { value: 0, percent_value: 0, percent: "0%" },
                  card: { value: 0, percent_value: 0, percent: "0%" },
                  total: 0
                }
              }
            },
            "2025": {
              sourceCashCardSplit: {
                APM: {
                  cash: { value: 124717.75, percent_value: 35.20, percent: "35.20%" },
                  card: { value: 229555, percent_value: 64.80, percent: "64.80%" },
                  total: 354272.75
                },
                POS: {
                  cash: { value: 444135, percent_value: 100, percent: "100%" },
                  card: { value: 0, percent_value: 0, percent: "0%" },
                  total: 444135
                }
              }
            },
            "2026": {
              sourceCashCardSplit: {
                APM: {
                  cash: { value: 45117.40, percent_value: 30.00, percent: "30.00%" },
                  card: { value: 105280, percent_value: 70.00, percent: "70.00%" },
                  total: 150397.40
                },
                POS: {
                  cash: { value: 197925, percent_value: 100, percent: "100%" },
                  card: { value: 0, percent_value: 0, percent: "0%" },
                  total: 197925
                }
              }
            }
          }
        },
        // Contract 0030017 for value type 4
        "0030017": {
          4: {
            "2024": {
              pndAppWeb: {
                PND: { value: 1837.15, percent_value: 21.94, percent: "21.94%" },
                "APP/WEB": { value: 6535, percent_value: 78.06, percent: "78.06%" },
                grand_total: 8372.15
              },
              pndSplit: {
                "PND :: COINS": { value: 1797.15, percent_value: 97.82, percent: "97.82%" },
                "PND :: EWALLET": { value: 40, percent_value: 2.18, percent: "2.18%" },
                "PND :: NOTES": { value: 0, percent_value: 0, percent: "0%" },
                total: 1837.15
              }
            },
            "2025": {
              pndAppWeb: {
                PND: { value: 559.09, percent_value: 28.47, percent: "28.47%" },
                "APP/WEB": { value: 1405, percent_value: 71.53, percent: "71.53%" },
                grand_total: 1964.09
              },
              pndSplit: {
                "PND :: COINS": { value: 519.09, percent_value: 92.85, percent: "92.85%" },
                "PND :: EWALLET": { value: 40, percent_value: 7.15, percent: "7.15%" },
                "PND :: NOTES": { value: 0, percent_value: 0, percent: "0%" },
                total: 559.09
              }
            },
            "2026": {
              pndAppWeb: {
                PND: { value: 207.59, percent_value: 24.35, percent: "24.35%" },
                "APP/WEB": { value: 645, percent_value: 75.65, percent: "75.65%" },
                grand_total: 852.59
              },
              pndSplit: {
                "PND :: COINS": { value: 207.59, percent_value: 100, percent: "100%" },
                "PND :: EWALLET": { value: 0, percent_value: 0, percent: "0%" },
                "PND :: NOTES": { value: 0, percent_value: 0, percent: "0%" },
                total: 207.59
              }
            }
          }
        }
      };

      // Hardcoded contract based on value_type
      let hardcodedContract = "";
      let responseData = {};

      if (valueType === 4) {
        hardcodedContract = "0030017";
        responseData = { [hardcodedContract]: mockDataMap[hardcodedContract][valueType] };
      } else if (valueType === 1 || valueType === 2 || valueType === 3) {
        hardcodedContract = "0030010";
        responseData = { [hardcodedContract]: mockDataMap[hardcodedContract][valueType] };
      } else {
        // Fallback for any other value_type
        hardcodedContract = "0030010";
        responseData = { [hardcodedContract]: mockDataMap[hardcodedContract][1] };
      }

      resolve({
        success: true,
        errorCode: 0,
        message: "data fetched successfully",
        meta: {
          contract: hardcodedContract,
          month: params.month || "May",
          months_included: ["Jan", "Feb", "Mar", "Apr", "May"],
          years: [2024, 2025, 2026],
          value_type: valueType,
        },
        data: responseData,
      });
    }, 500);
  });
};
